import {useEffect, useState} from "react";

import {chatSocket, type TChatSocketStatus} from "@/lib/chatSocket";
import {applyChatSocketEvent} from "@/lib/chatSocketCache";
import {useTokenStore} from "@/store/token";

// Drives the single shared chat WebSocket connection. Mount this ONCE near the
// app root: it connects when a user is logged in and tears the connection down
// on logout.
export const useChatSocket = (): {status: TChatSocketStatus} => {
  const userId = useTokenStore(state => state.userId);
  const [status, setStatus] = useState<TChatSocketStatus>(chatSocket.getStatus());

  useEffect(() => {
    if (!userId) return;
    const unsubscribeStatus = chatSocket.onStatus(setStatus);
    const unsubscribeMessages = chatSocket.onMessage(applyChatSocketEvent);
    chatSocket.start();
    return () => {
      unsubscribeStatus();
      unsubscribeMessages();
      chatSocket.stop();
    };
  }, [userId]);

  return {status};
};
